import { Text, View } from "@react-pdf/renderer";
import { PDFTableColumn } from "components/PDF/Table";
import { DividaAcordo } from "core/features/acordo/typings";
import { formatMoney } from "infra/helpers/number";
import moment from "moment";
import { useMemo } from "react";

function useDividasAcordoPdfColumns(): PDFTableColumn<DividaAcordo>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<DividaAcordo>[] = [];

    columns.push({
      title: "Vencimento",
      flexGrow: 0.4,
      render: (original) => (
        <View>
          <Text>{moment(original.dataVencimento).format("DD/MM/YYYY")}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Valor original",
      flexGrow: 0.6,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.valor)}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Multa",
      flexGrow: 0.4,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.valorMulta)}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Juros",
      flexGrow: 0.4,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.valorJuros)}</Text>
        </View>
      ),
    });
    columns.push({
      title: "Honorários",
      flexGrow: 0.5,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.valorHonorarios)}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Valor Atual",
      flexGrow: 0.6,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{formatMoney(original.valorTotal)}</Text>
        </View>
      ),
    });

    return columns;
  }, []);
}

export default useDividasAcordoPdfColumns;
